import * as React from 'react';

const ArrowForward = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <mask
      id="mask0_15384_9765"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="16"
      height="16"
    >
      <rect width="16" height="16" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_15384_9765)">
      <path
        d="M5.34984 14.6668L4.1665 13.4835L9.64984 8.00016L4.1665 2.51683L5.34984 1.3335L12.0165 8.00016L5.34984 14.6668Z"
        fill="#979797"
      />
    </g>
  </svg>
);
export default ArrowForward;
